/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { CountPendingAssistantProposalsQueryResponse, CountPendingAssistantProposalsPathParams, CountPendingAssistantProposalsQueryParams, CountPendingAssistantProposals400, CountPendingAssistantProposals401, CountPendingAssistantProposals403, CountPendingAssistantProposals404, CountPendingAssistantProposals409, CountPendingAssistantProposals500 } from "../../types/assistantProposalsController/CountPendingAssistantProposals.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getCountPendingAssistantProposalsUrl(organizationId: CountPendingAssistantProposalsPathParams["organizationId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/assistant-proposals/counts` as const }
  return res
}

/**
 * @summary Pending assistant-proposal count (farm-scoped)
 * {@link /api/organizations/:organizationId/assistant-proposals/counts}
 */
export async function countPendingAssistantProposals(organizationId: CountPendingAssistantProposalsPathParams["organizationId"], params?: CountPendingAssistantProposalsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<CountPendingAssistantProposalsQueryResponse, ResponseErrorConfig<CountPendingAssistantProposals400 | CountPendingAssistantProposals401 | CountPendingAssistantProposals403 | CountPendingAssistantProposals404 | CountPendingAssistantProposals409 | CountPendingAssistantProposals500>, unknown>({ method : "GET", url : getCountPendingAssistantProposalsUrl(organizationId).url.toString(), params, ... requestConfig })
  return res.data
}